import { Bot } from "lucide-react";
import { cn } from "@/lib/utils";

export function TypingIndicator() {
    return (
        <div className="flex gap-3 px-4 py-4 bg-muted/30 animate-in fade-in duration-300">
            <div className="flex-shrink-0">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-purple-500 to-pink-500 text-white">
                    <Bot className="h-4 w-4" />
                </div>
            </div>
            <div className="flex-1 min-w-0 space-y-1">
                <div className="flex items-baseline gap-2">
                    <span className="text-sm font-semibold">TurboAI</span>
                </div>
                <div className="flex gap-1 items-center py-2">
                    <div className={cn(
                        "w-2 h-2 rounded-full bg-muted-foreground/60",
                        "animate-bounce [animation-delay:-0.3s]"
                    )} />
                    <div className={cn(
                        "w-2 h-2 rounded-full bg-muted-foreground/60",
                        "animate-bounce [animation-delay:-0.15s]"
                    )} />
                    <div className={cn(
                        "w-2 h-2 rounded-full bg-muted-foreground/60",
                        "animate-bounce"
                    )} />
                </div>
            </div>
        </div>
    );
}
